import { State } from 'xstate';
import { pauseSubscription } from './pauseSubscription';

type PauseSubscriptionsMachine = typeof pauseSubscription;
type PauseSubscriptionState = State<PauseSubscriptionsMachine['context']>;

export const getPauseSubscriptionStatus = (
  machineState: PauseSubscriptionState
) => ({
  idle: machineState.matches('idle'),
  pauseSubscriptionLoading: machineState.matches('pauseSubscription'),
  pauseSubscriptionSuccess: machineState.matches('success'),
  pauseSubscriptionError: machineState.matches('error'),
});

export const getErrorCode = (machineState: PauseSubscriptionState) => {
  return machineState.context.error;
};

export const pauseSubscriptionSelectors = {
  getPauseSubscriptionStatus,
  getErrorCode,
};
